import { useFormField, FieldArray } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { QuestionCircleIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { emptyMapping } from '../helpers';
import { MappingRow } from './mapping_row';
import { Column } from './styles';
const tableHeadingContainerCss = "tecb668";
const TableHeadingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tableHeadingContainerCss, props.className)} />;
});
const headingContainerCss = "h19ywxgh";
const HeadingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headingContainerCss, props.className)} />;
});
const TableHeading = () => <TableHeadingContainer>
    <Column>
      <HeadingContainer>
        <BodyText weight="bold">
          {I18n.t('publisher.organization_settings.user_provisioning.groups.attribute_value.title')}
        </BodyText>
        <ProTip icon={QuestionCircleIcon} inline>
          {I18n.t('publisher.organization_settings.user_provisioning.groups.attribute_value.tooltip')}
        </ProTip>
      </HeadingContainer>
    </Column>
    <Column>
      <HeadingContainer>
        <BodyText weight="bold">
          {I18n.t('publisher.organization_settings.user_provisioning.groups.calendly_group.title')}
        </BodyText>
        <ProTip icon={QuestionCircleIcon} inline>
          {I18n.t('publisher.organization_settings.user_provisioning.groups.calendly_group.tooltip')}
        </ProTip>
      </HeadingContainer>
    </Column>
  </TableHeadingContainer>;
const MappingRows = () => {
  const [{
    value: mappings
  }] = useFormField({
    name: 'mappings'
  });
  const [focusableId, setFocusableId] = useState(null);
  return <FieldArray name="mappings" render={({
    push,
    replace,
    remove
  }) => <>
          {mappings.map(({
      id,
      key,
      groupId
    }, index) => <MappingRow key={id || key} index={index} push={push} replace={replace} remove={remove} autoFocus={focusableId === id} groupId={groupId} />)}
          <MinimalButton fontSize="medium" onClick={() => {
      const newElement = emptyMapping();
      push(newElement);
      setFocusableId(newElement.id);
    }}>
            {I18n.t('publisher.organization_settings.user_provisioning.groups.add_row')}
          </MinimalButton>
        </>} />;
};
export const MappingsControls = () => <>
    <TableHeading />
    <MappingRows />
  </>;

require("./mappings_controls.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./mappings_controls.js");